import script from "./list.vue?vue&type=script&setup=true&lang=ts"
export * from "./list.vue?vue&type=script&setup=true&lang=ts"

import "./list.vue?vue&type=style&index=0&id=7ae6879a&lang=scss&scoped=true"

import exportComponent from "D:\\work\\kaifengzimaoqu\\wt_front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7ae6879a"]])

export default __exports__